import { ConfigCmd, Item, PusherMode } from "dsabp-js"
import { createCanvas } from "../canvas.js"
import { rendererResolvers } from "../main.js"
import { drawRotatedImage, getImage, getTinted, toImage } from "../util.js"

const baseColor = "#2b9430"

rendererResolvers.push(
	({ toRel, item, config, other }) => {
		if (item != Item.PUSHER)
			return

		const angle = config.pusher?.angle ?? ConfigCmd.defaults.pusher.angle
		const defaultMode = config.pusher?.defaultMode ?? ConfigCmd.defaults.pusher.defaultMode
		const noPusherBeam = other.noPusherBeam

		return {
			discriminator: `${item.id}_${angle}_${noPusherBeam || defaultMode.enumValue}`,
			async render() {
				const imgBase = await getTinted(getImage(item.buildInfo[0].image), baseColor)
				const imgPusher = await getImage("pusher")

				const extraPx = 12
				const canvas = createCanvas(imgBase.width + extraPx * 2, imgBase.height + extraPx * 2)
				const ctx = canvas.getContext("2d")

				ctx.translate(extraPx, extraPx)
				ctx.drawImage(imgBase, 0, 0)

				const midX = imgBase.width / 2, midY = imgBase.height / 2

				const pushMode = defaultMode
				if (pushMode != PusherMode.DO_NOTHING && !noPusherBeam) {
					if (pushMode == PusherMode.PULL) {
						const imgBeam = await getTinted(getImage("pusher_beam"), "#ff88ff", 0.8)
						drawRotatedImage(ctx, imgBeam, 360 - angle, midX, midY, -imgBeam.width / 4.5, imgBeam.height / 2, imgBeam.width / 2, imgBeam.height, imgBeam.width / 1.5, 0, imgBeam.width / 1.5, imgBeam.height)
						drawRotatedImage(ctx, imgBeam, 360 - angle, midX, midY, -imgBeam.width / 2 + 4, imgBeam.height / 2, imgBeam.width / 2 + 4, imgBeam.height, 0, 0, imgBeam.width / 2 + 4, imgBeam.height)
					} else {
						const imgBeam = await getTinted(getImage("pusher_beam"), "#88ff88", 0.8)
						drawRotatedImage(ctx, imgBeam, 180 - angle, midX, midY, imgBeam.width, imgBeam.height / 2)
					}
				}

				drawRotatedImage(ctx, imgPusher, -angle, midX, midY, midX, midY)

				return [{
					image: await toImage(canvas),
					textureSizeOff: toRel(canvas.width - imgBase.width, canvas.height - imgBase.height),
					texturePosOff: toRel(-extraPx, -extraPx)
				}]
			}
		}
	}
)
